var $da07fe8ec87e6b68$exports = {};
$da07fe8ec87e6b68$exports = {
  "ascending": "stigende",
  "ascendingSort": function ascendingSort(args) {
    return "sortert etter kolonne ".concat(args.columnName, " i stigende rekkef\xF8lge");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " piksler");
  },
  "descending": "synkende",
  "descendingSort": function descendingSort(args) {
    return "sortert etter kolonne ".concat(args.columnName, " i synkende rekkef\xF8lge");
  },
  "resizerDescription": "Trykk p\xE5 Enter for \xE5 starte st\xF8rrelsesendring",
  "select": "Velg",
  "selectAll": "Velg alle",
  "sortable": "kolonne som kan sorteres"
};
export { $da07fe8ec87e6b68$exports as default };